import React, { useEffect } from "react";

// ✅ Import images
import projectBg from "../../images/bg/project-bg.png";
import gifRound from "../../images/icon/b10c3e43e836d32554bf.gif";
import projectImg01 from "../../images/project/project-img01.jpg";
import projectImg02 from "../../images/project/project-img02.jpg";
import projectImg03 from "../../images/project/project-img03.jpg";
import projectImg04 from "../../images/project/project-img04.jpg";

// ✅ Import icons
import icon01 from "../../images/icon/appstore.svg";
import icon02 from "../../images/icon/googleplay.png";
import icon03 from "../../images/icon/safal_school_erp.png";
import icon08 from "../../images/icon/project-icon08.svg";
import icon09 from "../../images/icon/project-icon09.svg";
import icon10 from "../../images/icon/project-icon10.svg";
import icon11 from "../../images/icon/project-icon11.svg";
import icon12 from "../../images/icon/project-icon12.svg";
import icon13 from "../../images/icon/project-icon13.svg";
import icon14 from "../../images/icon/revyv-chruhc.png";
import { Link } from "react-router-dom";

const ProjectSection: React.FC = () => {
  useEffect(() => {
    // ✅ Set dynamic background image
    const bgElement = document.querySelector<HTMLElement>(".project.bg_img");
    if (bgElement) {
      bgElement.style.backgroundImage = `url(${projectBg})`;
    }

    // ✅ Scroll activation logic
    const items = document.querySelectorAll<HTMLElement>(".xb-project-item");
    const paginations = document.querySelectorAll<HTMLElement>(".xb-project-pagination li");

    if (!items.length || !paginations.length) return;

    items.forEach((item) => {
      item.style.transition = "opacity 0.6s ease";
      item.style.opacity = "1";
    });

    const updateActive = () => {
      let indexToActivate = 0;
      const triggerLine = window.innerHeight * 0.3;

      items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        if (rect.top <= triggerLine) {
          indexToActivate = index;
        }
      });

      paginations.forEach((el) => el.classList.remove("active"));
      if (paginations[indexToActivate]) {
        paginations[indexToActivate].classList.add("active");
      }

      items.forEach((item, i) => {
        if (i === indexToActivate) {
          item.style.opacity = "1";
        } else if (i < indexToActivate) {
          item.style.opacity = "0.3";
        } else {
          item.style.opacity = "1";
        }
      });
    };

    window.addEventListener("scroll", updateActive);
    updateActive();

    return () => {
      window.removeEventListener("scroll", updateActive);
    };
  }, []);

  return (
    <section className="project bg_img pt-135 pb-150">
      <div className="container">
        <div className="sec-title custom-sec-title xb-sec-padding text-center">
          <span className="sub-title">Proprietary Tech</span>
          <h2 className="title">
            <span className="round-img">
              <img src={gifRound} alt="animation" />
            </span>{" "}
            Pioneering the Next Gen of Intelligent Solutions
          </h2>
          <div className="xb-heading-btn d-inline">
            <Link className="thm-btn agency-btn" to="/project">
              <span className="text">view more projects</span>
              <span className="arrow">
                <span className="arrow-icon">
                  {/* Double SVG arrow */}
                  {[...Array(2)].map((_, i) => (
                    <svg
                      key={i}
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="5.06592"
                        y="19.9785"
                        width="20.5712"
                        height="2.61221"
                        transform="rotate(-40.2798 5.06592 19.9785)"
                        fill="white"
                      />
                      <rect
                        x="7.97095"
                        y="7.24463"
                        width="2.61221"
                        height="2.61221"
                        transform="rotate(-40.2798 7.97095 7.24463)"
                        fill="white"
                      />
                      <rect
                        x="11.6523"
                        y="7.54834"
                        width="2.61221"
                        height="2.61221"
                        transform="rotate(-40.2798 11.6523 7.54834)"
                        fill="white"
                      />
                      <rect
                        x="15.334"
                        y="7.85205"
                        width="2.61221"
                        height="2.61221"
                        transform="rotate(-40.2798 15.334 7.85205)"
                        fill="white"
                      />
                      <rect
                        x="18.7119"
                        y="11.8374"
                        width="2.61221"
                        height="2.61221"
                        transform="rotate(-40.2798 18.7119 11.8374)"
                        fill="white"
                      />
                      <rect
                        x="18.4084"
                        y="15.52"
                        width="2.61221"
                        height="2.61221"
                        transform="rotate(-40.2798 18.4084 15.52)"
                        fill="white"
                      />
                      <rect
                        x="18.104"
                        y="19.2012"
                        width="2.61221"
                        height="2.61221"
                        transform="rotate(-40.2798 18.104 19.2012)"
                        fill="white"
                      />
                    </svg>
                  ))}
                </span>
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div className="container mxw-1800">
        <div className="xb-project-wrap">
          {/* Pagination */}
          <div className="xb-project-pagination-wrap">
            <ul className="xb-project-pagination">
              <li>1</li>
              <li className="active">2</li>
              <li>3</li>
              {/* <li>4</li> */}
            </ul>
          </div>

          {/* Project items */}
          <div className="xb-project-inner">
            {[
              {
                img: projectImg01,
                logo: icon03,
                link: "https://safalschool.com",
                title: "Safal School AI ERP",
                desc: "The Next Generation of Educational Management: Transform school administration with SafalSchool AI-ERP. We bridge the gap between complex data and effortless management, ensuring smarter enrollments, faster onboarding, and frictionless daily operations.",
                industry: "EdTech",
                country: "India",
                techs: [
                  { icon: icon02, link: "https://play.google.com/store/apps/details?id=com.safalschool.erp" },
                  { icon: icon01, link: "https://apps.apple.com" },
                ],
              },
              {
                img: projectImg02,
                logo: icon14,
                link: "https://revyv.church",
                title: "Revyv Church",
                desc: "Uniting Faith and Community: Revyv Church is a dedicated platform designed to bring churches and Christian communities together. Discover a seamless way to engage with your congregation, access spiritual resources, and grow in faith through our intuitive mobile experience.",
                industry: "FaithTech",
                country: "India, Canada",
                techs: [
                  { icon: icon02, link: "https://play.google.com/store/apps/details?id=com.revyvchurch.app" },
                  { icon: icon01, link: "https://apps.apple.com/us/app/sda-telugu-church-limbayat/id6751284826" },
                ],
              },
              {
                img: projectImg03,
                logo: null,
                link: null,
                title: "Suveeksha",
                desc: "SUVEEKSHA is a virtual reality learning platform provided directly to educational institutions, featuring learning modules and experiments from primary classes to high school lessons. Contact for demo.",
                industry: "AR/VR",
                country: "US, India",
                techs: [
                  { text: "Contact for Demo", link: "/contact-us" },
                ],
              },
              // {
              //   img: projectImg04,
              //   title: "Data science analytics..",
              //   desc: "We turn complex data into clear, actionable insights. From predictive models to real-time dashboards, our AI-powered analytics help businesses make smarter, faster decisions with confidence.",
              //   industry: "Data Science",
              //   country: "Canada",
              //   techs: [icon08, icon12, icon13],
              // },
            ].map((project, index) => (
              <div
                key={index}
                className="xb-project-item bg_img"
                style={{ backgroundImage: `url(${project.img})` }}
              >
                <div className="xb-project-content">
                  <div className="xb-item--inner xb-border">
                    <div className="xb-item--title-wrap" style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
                      {project.logo && project.link ? (
                        <a href={project.link} target="_blank" rel="noopener noreferrer">
                          <img src={project.logo} alt={project.title} style={{ height: '50px', width: 'auto', borderRadius: '12px' }} />
                        </a>
                      ) : project.logo ? (
                        <img src={project.logo} alt={project.title} style={{ height: '50px', width: 'auto', borderRadius: '12px' }} />
                      ) : null}
                      {project.link ? (
                        <a href={project.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                          <h2 className="xb-item--title" style={{ margin: 0 }}>{project.title}</h2>
                        </a>
                      ) : (
                        <h2 className="xb-item--title" style={{ margin: 0 }}>{project.title}</h2>
                      )}
                    </div>
                    <p className="xb-item--content">{project.desc}</p>
                    <ul className="xb-item--list ul_li">
                      <li>
                        Industry: <span>{project.industry}</span>
                      </li>
                      <li>
                        Country: <span>{project.country}</span>
                      </li>
                    </ul>
                    <div className="xb-item--technologie ul_li">
                      <span>Aviailable on:</span>
                      <ul className="list-unstyled ul_li">
                        {project.techs.map((tech: any, i) => (
                          <li key={i}>
                            {tech.text ? (
                              <Link to={tech.link} className="contact-demo-btn" style={{ padding: '8px 16px', background: 'var(--color-primary)', borderRadius: '8px', color: '#fff', textDecoration: 'none', fontSize: '14px', fontWeight: '500' }}>
                                {tech.text}
                              </Link>
                            ) : tech.link ? (
                              <a href={tech.link} target="_blank" rel="noopener noreferrer">
                                <img src={tech.icon} alt="icon" />
                              </a>
                            ) : (
                              <img src={tech.icon} alt="icon" />
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="xb-item---btn mt-70">
                      <Link className="thm-btn agency-btn" to="/project-details">
                        <span className="text">read more</span>
                        <span className="arrow">
                          <span className="arrow-icon">
                            {[...Array(2)].map((_, i) => (
                              <svg
                                key={i}
                                width="28"
                                height="28"
                                viewBox="0 0 28 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="5.06592"
                                  y="19.9785"
                                  width="20.5712"
                                  height="2.61221"
                                  transform="rotate(-40.2798 5.06592 19.9785)"
                                  fill="white"
                                />
                                <rect
                                  x="7.97095"
                                  y="7.24463"
                                  width="2.61221"
                                  height="2.61221"
                                  transform="rotate(-40.2798 7.97095 7.24463)"
                                  fill="white"
                                />
                                <rect
                                  x="11.6523"
                                  y="7.54834"
                                  width="2.61221"
                                  height="2.61221"
                                  transform="rotate(-40.2798 11.6523 7.54834)"
                                  fill="white"
                                />
                                <rect
                                  x="15.334"
                                  y="7.85205"
                                  width="2.61221"
                                  height="2.61221"
                                  transform="rotate(-40.2798 15.334 7.85205)"
                                  fill="white"
                                />
                                <rect
                                  x="18.7119"
                                  y="11.8374"
                                  width="2.61221"
                                  height="2.61221"
                                  transform="rotate(-40.2798 18.7119 11.8374)"
                                  fill="white"
                                />
                                <rect
                                  x="18.4084"
                                  y="15.52"
                                  width="2.61221"
                                  height="2.61221"
                                  transform="rotate(-40.2798 18.4084 15.52)"
                                  fill="white"
                                />
                                <rect
                                  x="18.104"
                                  y="19.2012"
                                  width="2.61221"
                                  height="2.61221"
                                  transform="rotate(-40.2798 18.104 19.2012)"
                                  fill="white"
                                />
                              </svg>
                            ))}
                          </span>
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section >
  );
};

export default ProjectSection;
